import * as React from 'react';
import { wrap, withRouterAndHelpers, withT } from '../../lib/wrappers';
import {get} from 'lodash';

interface Props {
  previousCalculatorPage: () => void;
  nextCalculatorPage: () => void;
  t: (key: string) => string;
  canNavToNext: boolean;
  canNavToPrevious: boolean;
  ui: any;
}

const NavButtons = ({
  previousCalculatorPage,
  nextCalculatorPage,
  t,
  canNavToNext,
  canNavToPrevious,
  ui
}: Props) => (
  <div className="cc-component__nav">
    {canNavToPrevious && <a className="nav_buttons__previous"  onClick={previousCalculatorPage}>{t('Previous')}</a>}
    {canNavToNext && <a  className="nav_buttons__next" onClick={nextCalculatorPage}>
      { !canNavToPrevious && get(ui, 'widget.options.source', 'none') === 'indigo' ? t('Refine your estimate') : t('Next')}
    </a>}
  </div>
);

export default wrap(
  withRouterAndHelpers,
  withT('common'),
  NavButtons
);
